import { render } from "./configForm.vue?vue&type=template&id=3269f1b4&scoped=true"
import script from "./configForm.vue?vue&type=script&lang=js"
export * from "./configForm.vue?vue&type=script&lang=js"

import "./configForm.vue?vue&type=style&index=0&id=3269f1b4&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3269f1b4"]])

export default __exports__